<template>
  <div class="main__cruise-ticket container">
    <div class="summary">
      <div class="summary__header">
        <!--        <div><i class="icon icon-tada"></i></div>-->
        <!--        <div class="summary__success">SUCCESS</div>-->
        <!--        <div class="title-thank-you">-->
        <!--          Thank you for completing <br />the online check-in process-->
        <!--          <br/> Click <a href="https://www.aquaexpeditions.com/your-pre-cruise-information/" target="_blank">here</a> for your Pre-cruise Information.-->
        <!--        </div>-->
      </div>
      <div class="summary__content">
        <!--

        <div class="cruise-ticket-preview">
          <img :src="cruiseTicketURL" />
        </div>

        -->
        <div class="summary__content-title">Booking details</div>
        <div class="summary__divider"></div>

        <div class="tickets">
          <el-row
            v-for="(cc, index) in cabinConfigurations"
            :key="cc.cabinConfigurationID"
            class="cabin-configuration"
            type="flex"
          >
            <el-col :span="8">
              <div class="cabin-configuration__label">Guest(s)</div>
              <div
                v-for="guestName in getGuestNameList(cc)"
                class="cabin-configuration__guest"
              >
                {{ guestName }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="cabin-configuration__label">Suite</div>
              <div class="cabin-configuration__suite">
                <i class="icon icon-design-suite" />{{ cc.suite }}
              </div>
              <div class="cabin-configuration__suite">
                <i class="icon icon-deck" />{{ cc.deck }}
              </div>
              <div
                v-if="canShowBalconyType()"
                class="cabin-configuration__suite"
              >
                <i class="icon icon-balcony" />{{
                  cc.hasBalcony ? "Balcony" : "Non-balcony"
                }}
              </div>
              <div
                v-if="cc.interconnectingCabin"
                class="cabin-configuration__suite"
              >
                <i class="icon icon-interconnecting" />Interconnecting with
                Suite
                {{ cc.interconnectingCabin }}
              </div>
            </el-col>
            <!--            BUTTONS FOR CRUISE TICKET -->
            <!--            <el-col :span="8" class="v-h-center">-->
            <!--              <a :href="cc.cruiseTicketURL"-->
            <!--                 class="el-button el-button&#45;&#45;primary el-button&#45;&#45;saveCruiseTicket" download-->
            <!--                 target="_blank">Save cruise ticket</a>-->
            <!--              <a :href="cc.cruiseTicketURL"-->
            <!--                 class="el-button el-button&#45;&#45;primary el-button&#45;&#45;printCruiseTicket"-->
            <!--                 style="margin-left: 0;" target="_blank">Print cruise-->
            <!--                ticket</a>-->
            <!--              &lt;!&ndash;<el-button type="primary" @click="onClickPrintTicket(cc.cruiseTicketURL)" style="margin-left: 0;">Print cruise ticket</el-button>&ndash;&gt;-->
            <!--            </el-col>-->
          </el-row>
        </div>

        <div class="loyalty">
          <div class="loyalty__note">
            Thank you for being a part of Circolo Aqua — you will receive
            exclusive onboard benefits during your expedition. We look forward
            to welcoming you on board!
          </div>
          <el-button
            class="button--primary bottom-nav__primaryButton"
            @click="onClickExploreBenefits"
            >Explore Benefits</el-button
          >
        </div>

        <div class="emergency-contacts">
          <el-row :gutter="40">
            <el-col :span="24">
              <h1 class="emergency-contacts__title">Pre-departure contact</h1>
              <div class="emergency-contacts__operational">
                <div class="emergency-contacts__operational__title">
                  Guest Relations Coordinator for Asia:
                </div>
                <div class="emergency-contacts__operational__contact-no">
                  Shearly Loilewen (Based in Indonesia)
                  <br />
                  +62 853388 19530
                </div>
                <br />
                <div class="emergency-contacts__operational__contact-no">
                  Andy Nguyen (Based in Vietnam)
                  <br />
                  +84 377 660 183
                </div>
              </div>
              <div class="emergency-contacts__operational">
                <div class="emergency-contacts__operational__title">
                  Guest Relations Coordinator for South America:
                </div>
                <div class="emergency-contacts__operational__contact-no">
                  Fiorella Salazar (Based in Peru)
                  <br />
                  +51 959 891 991
                </div>
                <br />
                <div class="emergency-contacts__operational__contact-no">
                  Jhuliana Villa (Based in Peru)
                  <br />
                  +51 961 770 280
                </div>
              </div>
              <div class="emergency-contacts__operational">
                <div class="emergency-contacts__operational__title">
                  Guest Relations Coordinator for Africa:
                </div>
                <div class="emergency-contacts__operational__contact-no">
                  Annabel Mahoune (based in Seychelles)
                  <br />
                  +254 208787935
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--        FOR EMAILING CRUISE TICKET-->
        <!--        <div class="section-title">Don't have a printer with you now?</div>-->

        <!--        <el-form ref="form"-->
        <!--                 :model="formData"-->
        <!--                 :rules="rulesValidate"-->
        <!--                 label-position="top">-->
        <!--          <el-row>-->
        <!--            <el-col :span="12">-->
        <!--              <el-form-item label="Receive the cruise ticket via email" prop="email">-->
        <!--                <el-input-->
        <!--                    v-model="formData.email"-->
        <!--                    placeholder="Your email address"-->
        <!--                    type="email" />-->
        <!--              </el-form-item>-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <!--          <el-row>-->
        <!--            <el-col :span="12">-->
        <!--              <el-form-item prop="name">-->
        <!--                <el-input-->
        <!--                    v-model="formData.name"-->
        <!--                    placeholder="Your name"-->
        <!--                    type="text" />-->
        <!--              </el-form-item>-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <!--        </el-form>-->

        <!--        <el-button :loading="showLoadingSendEmail" type="primary" @click="onClickSendEmail">Send-->
        <!--        </el-button>-->

        <hr />

        <div class="note">
          If you have any further questions, please
          <a :href="appendMarketingSiteUrl('/contact-us')" target="_blank"
            >contact us</a
          >.
        </div>
      </div>

      <div class="bottom-nav"></div>

      <el-dialog :visible.sync="dialogEmailVisible" class="dialog-email">
        <i class="icon icon-sent"></i>
        <h2>Your cruise ticket will be sent to</h2>
        <div class="email">{{ formData.email }}</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import { FACILITY_CODES, UNHANDLED_ERROR_MESSAGE } from "../constants";

export default {
  created() {
    gtag("set", "page_path", "/completed");
    gtag("event", "page_path", {
      path: "/completed",
    });
  },
  data() {
    return {
      dialogEmailVisible: false,
      showLoadingSendEmail: false,
      formData: {
        email: "",
        name: "",
      },
      rulesValidate: {
        email: [
          {
            required: true,
            message: "Required",
            trigger: "change blur",
          },
          {
            type: "email",
            message: "Invalid email format",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "Required", trigger: "change blur" }],
      },
    };
  },
  computed: {
    ...mapGetters([
      types.getters.booking,
      types.getters.cabinConfigurations,
      types.getters.cruiseTicketURL,
      types.getters.contacts,
      types.getters.contact,
    ]),
  },
  methods: {
    ...mapActions([types.actions.sendCruiseTicketEmailRemote]),
    appendMarketingSiteUrl(path) {
      return `${process.env.MARKETING_SITE_FRONTEND_URL}${path || ""}`;
    },
    canShowBalconyType: function () {
      return (
        !this.booking.isAmazonCruise &&
        this.booking.facilityCode !== FACILITY_CODES.AquaBlu &&
        this.booking.facilityCode !== FACILITY_CODES.AquaMare
      );
    },
    getGuestNameList: function (cabinConfiguration) {
      // Search for contact's name under 'contacts' based on given contact id(s) in cabinConfiguration.
      let errorEncountered = false;
      let $this = this;

      // Get valid contact IDs.
      let contactIds = [
        cabinConfiguration.guest1ID,
        cabinConfiguration.guest2ID,
        cabinConfiguration.guest3ID,
        cabinConfiguration.guest4ID,
      ].filter((id) => id);

      const result = contactIds.map((contactId) => {
        // Utilise getter to retrieve the cabin config's guest contact based on the contactId,
        // equivalent to: this.contacts.find(contact => contact.contactID === contactId);
        const currentContact = this.contact(contactId);

        if (currentContact) {
          // use join with delimiter just in case firstName or lastName is an empty string
          return [currentContact.firstName, currentContact.lastName].join(" ");
        }

        // Unexpected error if can't find contact.
        errorEncountered = true;
        return null;
      });

      if (result.length && !errorEncountered) {
        return result;
      } else {
        // Name(s) found in cabinConfiguration MIGHT be outdated if it was fetched initially but was updated afterwards during check-in.
        // Only used as a failsafe now (since defaults to using names found in contacts instead).
        return [
          cabinConfiguration.guest1Name,
          cabinConfiguration.guest2Name,
          cabinConfiguration.guest3Name,
          cabinConfiguration.guest4Name,
        ].filter((guestName) => guestName);
      }
    },
    onClickPrintTicket: function (cruiseTicketURL) {
      function getPrintHTML(source) {
        return (
          `<html>
  <head>
    <script>
      function step1() {
        setTimeout('step2()', 10);
      }
      function step2(){
        window.print();
        window.close();
      }
    </scri` +
          `pt>
  </head>
  <body onload='step1()'>
    <img src="${source}" style="width: 100%;" />
  </body>
</html>`
        );
      }

      const newPage = window.open("about:blank", "_new");
      newPage.document.open();
      newPage.document.write(getPrintHTML(cruiseTicketURL));
      newPage.document.close();
    },
    onClickSendEmail: function () {
      this.$refs.form
        .validate()
        .then(() => {
          this.showLoadingSendEmail = true;
          this.sendCruiseTicketEmailRemote({
            cabinConfigurations: this.cabinConfigurations,
            email: this.formData.email,
            name: this.formData.name,
          })
            .catch((error) => {
              this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
            })
            .then(() => {
              this.dialogEmailVisible = true;
            })
            .finally(() => {
              this.showLoadingSendEmail = false;
            });
        })
        .catch((error) => {
          console.log("error:", error);
        });
    },
    onClickBack: function () {
      this.$router.back();
    },
    onClickExploreBenefits: function () {
      window.open(this.appendMarketingSiteUrl(`/loyalty`), "_blank");
    },
  },
};
</script>
<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.main__cruise-ticket {
  .el-form--label-top {
    .el-form-item__label {
      padding-bottom: 15px;
    }
  }

  .el-form-item {
    margin-bottom: 32px;
  }

  .el-button--primary {
    padding: 8px 16px;
    min-width: 148px;
    @include typo(16);
  }

  .dialog-email {
    text-align: center;

    .el-dialog {
      width: 834px;

      &__header {
        padding: 0;
      }

      &__body {
        padding: 226px 203px 119px 203px;
      }
    }

    .icon {
      top: 119px;
      left: 50%;
      transform: translateX(-50%);
    }

    h2 {
      margin-top: 0;
      margin-bottom: 16px;
      @include typo-light(32);
    }

    .email {
      @include typo-bold(32);
      color: $text-title-blue;
    }
  }

  .v-h-center {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;

    // IE work around for space-evenly
    a {
      &:first-child {
        margin-top: auto;
        margin-bottom: 6px;
      }

      &:last-child {
        margin-top: 6px;
        margin-bottom: auto;
      }
    }
  }

  .section-title {
    margin-bottom: 24px;
    @include typo-bold(24);
    color: $text-title-blue;
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.summary {
  //margin-top: 66px;
  color: $text-normal-color;

  &__header {
    //padding-top: 65px;
    //padding-bottom: 65px;

    //.icon {
    //  left: 50%;
    //  transform: translateX(-50%);
    //}

    .summary__success {
      color: $aqua-grey-50;
      text-align: center;
      @include global-paragraph-small-regular;
    }

    .title-thank-you {
      margin-top: 16px;
      margin-bottom: 48px;
      //@include typo-light(32);
      text-align: center;
      @include desktop-title-title2;
    }

    img {
      width: 100%;
      height: 400px;
      background-size: cover;
      background-repeat: no-repeat;
      //background-position: top center;
    }
  }

  &__content {
    padding: 40px;
    background-color: #fff;

    &-title {
      @include global-paragraph-x-large-bold;
      color: $aqua-grey-100;
      padding-bottom: 16px;
      border-bottom: 1px solid $aqua-grey-25;
    }
  }
}

.tickets {
  margin-bottom: 40px;
}

.cruise-ticket-preview {
  margin-top: -161px;
  margin-bottom: 40px;
  min-height: 287px;
  min-width: 1056px;
  background-color: #f4f4f4;

  img {
    display: block;
    width: 100%;
  }
}

.el-button--saveCruiseTicket,
.el-button--printCruiseTicket {
  &:hover {
    text-decoration: none;
  }
}

.cabin-configuration {
  padding: 48px 0;
  border-bottom: 1px solid $line-color;
  color: $aqua-grey-100;

  .el-col {
    padding-left: 32px;
    padding-right: 32px;
    border-left: 1px solid $line-color;
    border-right: 1px solid $line-color;

    &:first-child {
      padding-left: 0;
      margin-left: 1px;
      margin-right: -1px;
      border-left: 0;
    }

    &:last-child {
      padding-right: 0;
      margin-left: -1px;
      margin-right: 1px;
      border-right: 0;
    }
  }

  &__label {
    @include global-paragraph-medium-regular;
    margin-bottom: 8px;
    color: $aqua-grey-90;
  }

  &__guest {
    margin-bottom: 8px;
    @include global-paragraph-medium-bold;
  }

  &__suite {
    position: relative;
    margin-bottom: 6px;
    padding-left: 32px;
    @include global-paragraph-medium-regular;

    i {
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      color: $aqua-blue-100;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.insurance {
  &__cta {
    margin-bottom: 18px;

    &:hover {
      text-decoration: none;
    }
  }

  &__title {
    margin-top: 50px;
    margin-bottom: 24px;
    @include typo-bold(24);
    color: $text-title-blue;
  }

  &__logo {
    margin-top: 6px;
    margin-bottom: 24px;
    width: 180px;
    height: 48px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("../assets/images/ripcord-logo.png");
  }

  &__subtitle {
    margin-bottom: 24px;
    color: #4a4a4a;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }

  &__description {
    margin-bottom: 108px;
    color: $tag-text-color;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
  }

  &__external-notice {
    margin-left: 32px;
    padding-top: 14px;
    color: #4a4a4a;
    font-size: 14px;
    line-height: 12px;
  }

  &__info-box {
    padding: 12px 0;
    margin-bottom: 32px;
    //max-width: 600px;
    background-color: $summary-blue;

    ul {
      margin: 0;
      padding-left: 24px;
    }

    li {
      list-style-position: inside;
      padding: 12px 24px 12px 18px;
      text-indent: -21px;

      color: #4a4a4a;
      /*font-family: Lato;*/
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.loyalty {
  &__note {
    margin-bottom: 32px;
  }
}

.emergency-contacts {
  padding-top: 32px;
  color: $aqua-grey-100;

  &__title {
    @include global-paragraph-x-large-bold;
    padding-bottom: 16px;
    border-bottom: 1px solid $aqua-grey-25;
    margin-bottom: 32px;
  }
  &__operational {
    margin-bottom: 40px;

    &__title {
      @include global-paragraph-large-bold;
      //margin-bottom: 8px;
    }
    &__contact-no {
      @include global-paragraph-medium-regular;
    }
  }
}

.note {
  display: inline-block;
  margin-top: 16px;
  @include global-paragraph-medium-regular;
  color: $aqua-grey-90;
  background-color: #ecf1f5;
  padding: 6px 12px;

  a {
    @include global-paragraph-medium-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CruiseTicketPage.vue